import React from 'react';
import './StickyContactBar.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';

const StickyContactBar = () => {
  return (
    <div className="sticky-contactbar">
      <div className="sticky-col-wrapper">
        {/* Left: Phone + Email */}
        <div className="sticky-col contact-info">
          <a href="tel:352-812-0831" aria-label="Call Watkins Seamless Gutters">
            <i className="fa-solid fa-phone" /> 352-812-0831
          </a>
          <span className="divider">/</span>
          <a
            href="mailto:GuttersByWatkins@gmail.com"
            aria-label="Send an email to Gutters By Watkins"
          >
            <i className="fa-solid fa-envelope" /> GuttersByWatkins@gmail.com
          </a>
        </div>

        {/* Right: CTA Button */}
        <div className="sticky-col cta">
          <Link
            to="/free-estimate" /* could scroll to your contact/estimate form */
            className="cta-button"
            aria-label="Request a free estimate from Watkins Seamless Gutters"
          >
            SCHEDULE TODAY <i className="fa-solid fa-arrow-right-long"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StickyContactBar;
